import angular from 'angular';
import {GiftCardsRouterConstantsType} from './ib-gift-cards-router-constants';
class RouterConfig {

    constructor (private $routeProvider: any, private GiftCardsRouterConstants: GiftCardsRouterConstantsType) {

    }

    active = ():void => {
        this.$routeProvider.
            when(this.GiftCardsRouterConstants.PAGES_URL.GIFTCARD_CONFIGURATION, {
                template: '<ib-gift-cards-configuration></ib-gift-cards-configuration>',
                reloadOnSearch: false
            }).when(this.GiftCardsRouterConstants.PAGES_URL.GIFTCARD_CONTRIBUTION, {
                template: '<ib-gc-new-contribution-component></ib-gc-new-contribution-component>',
                reloadOnSearch: false
            }).when('/ibpurc', {
                templateUrl: this.GiftCardsRouterConstants.TEMPLATES_ROUTE + this.GiftCardsRouterConstants.PAYMENT_ROUTE,
                controller: 'PmtPageController',
                controllerAs: 'paymentCtrl',
                reloadOnSearch: false
            }).when(this.GiftCardsRouterConstants.PAGES_URL.GIFTCARD_PAYMENTS, {
                template: '<ib-gc-payments-component></ib-gc-payments-component>',
                reloadOnSearch: false
            }).when(this.GiftCardsRouterConstants.PAGES_URL.GIFTCARD_NEW_CONFIRMATION, {
                template: '<ib-gc-confirmation-component></ib-gc-confirmation-component>',
                reloadOnSearch: false
            }).when(this.GiftCardsRouterConstants.PAGES_URL.GIFTCARD_CONFIRMATION, {
                templateUrl: this.GiftCardsRouterConstants.TEMPLATES_ROUTE + this.GiftCardsRouterConstants.CONFIRMATION_ROUTE,
                controller: 'GiftCardsConfirmationController',
                controllerAs: 'confirmationCtrl',
                reloadOnSearch: false
            }).when(this.GiftCardsRouterConstants.PAGES_URL.GIFTCARD_ERROR, {
                template: '<ib-gift-cards-generic-error></ib-gift-cards-generic-error>',
                reloadOnSearch: false
            }).otherwise({
                redirectTo: this.GiftCardsRouterConstants.PAGES_URL.GIFTCARD_CONFIGURATION
            });
    };
    $onInit = this.active();
}
RouterConfig.$inject = ['$routeProvider', 'GiftCardsRouterConstants'];
try {
    angular.module('ib-gift-cards-routing-module').config( RouterConfig);
} catch (error) {
    const mod = angular.module('ib-gift-cards-routing-module', []);
    mod.config(RouterConfig);
}
